import { ProductExtended } from '@floori/models';

export interface FlooriArDialogData {
    product: ProductExtended;
}

export enum ArDialogAction {
    AR = 'ar',
    THREE_D = '3d',
}

export interface ArModelUrls {
    usdzUrl?: string;
    gltfUrl?: string;
}
